// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { Config } from '../.env.js';
// import { useLocation } from 'react-router-dom';

// const Table = () => {
//   const [data, setData] = useState([]);
//   const location = useLocation();
//   const campaignName = location.state?.campaignName;

//   const [orders, setOrders] = useState([]);
//   const [refunds, setRefunds] = useState([]);
//   const [mergedData, setMergedData] = useState([]);

//   useEffect(() => {
//     const fetchAllData = async () => {
//       try {
//         const [orderRes, refundRes] = await Promise.all([
//           axios.get(`${Config.API_URL}/api/order-data`, {
//             params: { campaignName },
//           }),
//           axios.get(`${Config.API_URL}/api/refunds`, {
//             params: { campaignName },
//           }),
//         ]);

//         const orderData = orderRes.data;
//         const refundData = refundRes.data;

//         setOrders(orderData);
//         setRefunds(refundData);

//         // Map refunds by contactId for fast lookup
//         const refundMap = refundData.reduce((acc, item) => {
//           if (item.contactId) acc[item.contactId] = item;
//           return acc;
//         }, {});

//         // Step 1: Orders with matched refund info
//         const combined = orderData.map((order) => {
//           const refund = refundMap[order.contactId];
//           return {
//             ...order,
//             refundStatus: refund?.status || null,
//             refundReasons: refund?.reasons || [],
//             refundPaymentStatus: refund?.paymentStatus || null,
//             refundId: refund?._id || null,
//             inputValue2: refund?.inputValue2 || null, // link from refund
//           };
//         });

//         // Step 2: Refunds that do NOT exist in orderData
//         const existingContactIds = new Set(orderData.map((o) => o.contactId));
//         const unmatchedRefunds = refundData
//           .filter((r) => !existingContactIds.has(r.contactId))
//           .map((r) => ({
//             ...r,
//             FullName: '',
//             order: r.order,
//             refundStatus: r.status,
//             refundReasons: r.reasons || [],
//             refundPaymentStatus: r.paymentStatus,
//             refundId: r._id,
//             inputValue2: r.inputValue2,
//           }));

//         // Step 3: Final merged result
//         const finalMerged = [...combined, ...unmatchedRefunds];
//         setMergedData(finalMerged);
//       } catch (error) {
//         console.error('❌ Error fetching or merging data:', error);
//       }
//     };

//     if (campaignName) {
//       fetchAllData();
//     }
//   }, [campaignName]);



//   const handleApprove = async (orderId) => {
//     try {
//       await axios.post(`${Config.API_URL}/api/approve-order`);
//       setData((prevData) =>
//         prevData.map((item) =>
//           item.orderId === orderId ? { ...item, status: 'Approved' } : item
//         )
//       );
//     } catch (error) {
//       console.error('Error approving order:', error);
//     }
//   };



//   // Drag-scroll logic
//   let isDown = false;
//   let startX;
//   let scrollLeft;

//   const handleMouseDown = (e) => {
//     const slider = e.currentTarget;
//     isDown = true;
//     slider.classList.add('active');
//     startX = e.pageX - slider.offsetLeft;
//     scrollLeft = slider.scrollLeft;
//   };

//   const handleMouseLeave = (e) => {
//     isDown = false;
//     e.currentTarget.classList.remove('active');
//   };

//   const handleMouseUp = (e) => {
//     isDown = false;
//     e.currentTarget.classList.remove('active');
//   };

//   const handleMouseMove = (e) => {
//     if (!isDown) return;
//     e.preventDefault();
//     const slider = e.currentTarget;
//     const x = e.pageX - slider.offsetLeft;
//     const walk = (x - startX) * 2;
//     slider.scrollLeft = scrollLeft - walk;
//   };

//   return (
//     <div className="container mt-5">
//       <div
//         className="table-container"
//         style={{
//           overflowX: 'auto',
//           cursor: 'grab',
//         }}
//         onMouseDown={handleMouseDown}
//         onMouseLeave={handleMouseLeave}
//         onMouseUp={handleMouseUp}
//         onMouseMove={handleMouseMove}
//       >
//         <table className="table is-fullwidth" style={{ minWidth: '1500px' }}>
//           <thead>
//             <tr>
//               <th className="customStyle">Full Name</th>
//               <th className="customStyle">Instagram</th>
//               <th className="customStyle">Facebook</th>
//               <th className="customStyle">Twitter</th>
//               <th className="customStyle">YouTube</th>
//               <th className="customStyle">Custom Social</th>
//               <th className="customStyle">Gender</th>
//               <th className="customStyle">Whatsapp</th>
//               <th className="customStyle">Phone</th>
//               <th className="customStyle">Custom MarketPlace</th>
//               <th className="customStyle">Custom Review</th>
//               <th className="customStyle">Custom Profile Link</th>
//               <th className="customStyle">Email</th>
//               <th className="customStyle">Order</th>
//               <th className="customStyle">Quantity</th>
//               <th className="customStyle">Product Amount</th>
//               <th className="customStyle">Date</th>
//               <th className="customStyle">Student</th>
//               <th className="customStyle">College</th>
//               <th className="customStyle">Manager</th>
//               <th className="customStyle">Whatsapp Group</th>
//               <th className="customStyle">Pin Code</th>
//               <th className="customStyle">City</th>
//               <th className="customStyle">Product Question</th>

//               <th className="customStyle">Bank Name</th>
//               <th className="customStyle">Ifsc</th>
//               <th className="customStyle">Beneficiary Name</th>
//               <th className="customStyle">Account Number</th>
//               <th className="customStyle">UPI Number</th>
//               <th className="customStyle">Invoice Number</th>
//               <th className="customStyle">Deliverable Link</th>
//               <th className="customStyle">Actions</th>

//             </tr>
//           </thead>
//           <tbody>
//             {mergedData.map((item, index) => (
//               <tr key={index}>
//                 {/* Existing order fields */}
//                 <td className="customStyle">{item.FullName}</td>
//                 <td className="customStyle">{item.AuthInstagram}</td>
//                 <td className="customStyle">{item.AuthFacebook}</td>
//                 <td className="customStyle">{item.AuthTwitter}</td>
//                 <td className="customStyle">{item.AuthYouTube}</td>
//                 <td className="customStyle">{item.AuthCustomSocial}</td>
//                 <td className="customStyle">{item.gender}</td>
//                 <td className="customStyle">{item.whatsapp}</td>
//                 <td className="customStyle">{item.Phone}</td>
//                 <td className="customStyle">{item.customMarketPlaceName}</td>
//                 <td className="customStyle">{item.review}</td>
//                 <td className="customStyle">{item.customForoum}</td>
//                 <td className="customStyle">{item.email}</td>
//                 <td className="customStyle">{item.order}</td>
//                 <td className="customStyle">{item.quantity}</td>
//                 <td className="customStyle">{item.productAmount}</td>
//                 <td className="customStyle">{item.date}</td>
//                 <td className="customStyle">{String(item.student) === 'true' ? 'Yes' : 'No'}</td>
//                 <td className="customStyle">{item.collegeName}</td>
//                 <td className="customStyle">{item.manger}</td>
//                 <td className="customStyle">{item.whatsappGroup}</td>
//                 <td className="customStyle">{item.pinCode}</td>
//                 <td className="customStyle">{item.city}</td>
//                 <td className="customStyle">{item.productSS}</td>
//                 <td className="customStyle">{item.bankName}</td>
//                 <td className="customStyle">{item.ifsc}</td>
//                 <td className="customStyle">{item.beneficiaryName}</td>
//                 <td className="customStyle">{item.accountNumber}</td>
//                 <td className="customStyle">{item.UPI}</td>
//                 <td className="customStyle">{item.invoiceNumber}</td>

//                 {/* Refund data fields */}
//                 {/* <td className="customStyle">{item.refundStatus}</td>
//                 <td className="customStyle">
//                   {Array.isArray(item.refundReasons)
//                     ? item.refundReasons.join(', ')
//                     : item.refundReasons}
//                 </td> */}
//                 {/* <td className="customStyle">{item.refundPaymentStatus}</td>
//                 <td className="customStyle">
//                   {item.inputValue3 ? (
//                     <a href={`${Config.API_URL}/${item.inputValue3}`} target="_blank" rel="noopener noreferrer">View</a>
//                   ) : (
//                     '-'
//                   )}
//                 </td>
//                 <td className="customStyle">
//                   {item.inputValue4 ? (
//                     <a href={`${Config.API_URL}/${item.inputValue4}`} target="_blank" rel="noopener noreferrer">View</a>
//                   ) : (
//                     '-'
//                   )}
//                 </td> */}
//                 <td className="customStyle">
//                   {item.inputValue2}
//                 </td>

//                 {/* Action Button */}
//                 <td className="customStyle">
//                   <button
//                     onClick={() => handleApprove(item.orderId)}
//                     className="button is-primary"
//                   >
//                     Reminder
//                   </button>
//                 </td>
//               </tr>
//             ))}
//           </tbody>

//         </table>
//       </div>
//     </div>
//   );
// };

// export default Table;
// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { Config } from '../.env.js';
// import { useLocation } from 'react-router-dom';

// const Table = () => {
//   const [data, setData] = useState([]);
//   const location = useLocation();
//   const campaignName = location.state?.campaignName;

//   const [orders, setOrders] = useState([]);
//   const [refunds, setRefunds] = useState([]);
//   const [mergedData, setMergedData] = useState([]);

//   // useEffect(() => {
//   //   const fetchAllData = async () => {
//   //     try {
//   //       const [orderRes, refundRes] = await Promise.all([
//   //         axios.get(`${Config.API_URL}/api/order-data`, {
//   //           params: { campaignName },
//   //         }),
//   //         axios.get(`${Config.API_URL}/api/refunds`, {
//   //           params: { campaignName },
//   //         }),
//   //       ]);

//   //       const orderData = orderRes.data;
//   //       const refundData = refundRes.data;
//   //       console.log('refundData',refundData);
//   //       console.log('orderData',orderData);

//   //       setOrders(orderData);
//   //       setRefunds(refundData);

//   //       // Map refunds by contactId for fast lookup
//   //       const refundMap = refundData.reduce((acc, item) => {
//   //         if (item.contactId) acc[item.contactId] = item;
//   //         return acc;
//   //       }, {});

//   //       // Step 1: Orders with matched refund info
//   //       const combined = orderData.map((order) => {
//   //         const refund = refundMap[order.contactId];
//   //         return {
//   //           ...order,
//   //           refundStatus: refund?.status || null,
//   //           refundReasons: refund?.reasons || [],
//   //           refundPaymentStatus: refund?.paymentStatus || null,
//   //           refundId: refund?._id || null,
//   //           inputValue2: refund?.inputValue2 || null, // link from refund
//   //         };
//   //       });

//   //       // Step 2: Refunds that do NOT exist in orderData
//   //       const existingContactIds = new Set(orderData.map((o) => o.contactId));
//   //       const unmatchedRefunds = refundData
//   //         .filter((r) => !existingContactIds.has(r.contactId))
//   //         .map((r) => ({
//   //           ...r,
//   //           FullName: '',
//   //           order: r.order,
//   //           refundStatus: r.status,
//   //           refundReasons: r.reasons || [],
//   //           refundPaymentStatus: r.paymentStatus,
//   //           refundId: r._id,
//   //           inputValue2: r.inputValue2,
//   //         }));

//   //       // Step 3: Final merged result
//   //       const finalMerged = [...combined, ...unmatchedRefunds];
//   //       setMergedData(finalMerged);
//   //     } catch (error) {
//   //       console.error('❌ Error fetching or merging data:', error);
//   //     }
//   //   };

//   //   if (campaignName) {
//   //     fetchAllData();
//   //   }
//   // }, [campaignName]);


//   useEffect(() => {
//     const fetchAllData = async () => {
//       try {
//         const [orderRes, refundRes] = await Promise.all([
//           axios.get(`${Config.API_URL}/api/order-data`, {
//             params: { campaignName },
//           }),
//           axios.get(`${Config.API_URL}/api/refunds`), // Remove campaignName filter
//         ]);

//         const orderData = orderRes.data;
//         const refundData = refundRes.data;
//         console.log("refundData", refundData);
//         console.log("orderData", orderData);

//         setOrders(orderData);
//         setRefunds(refundData);

//         // Map refunds by contactId for fast lookup
//         const refundMap = refundData.reduce((acc, item) => {
//           if (item.contactId) acc[item.contactId] = item;
//           return acc;
//         }, {});

//         // Step 1: Orders with matched refund info
//         const combined = orderData.map((order) => {
//           const refund = refundMap[order.contactId];
//           return {
//             ...order,
//             refundStatus: refund?.status || null,
//             refundReasons: refund?.reasons || [],
//             refundPaymentStatus: refund?.paymentStatus || null,
//             refundId: refund?._id || null,
//             inputValue2: refund?.inputValue2 || null,
//           };
//         });

//         // Step 2: Refunds that do NOT exist in orderData
//         const existingContactIds = new Set(orderData.map((o) => o.contactId));
//         const unmatchedRefunds = refundData
//           .filter((r) => !existingContactIds.has(r.contactId))
//           .map((r) => ({
//             ...r,
//             FullName: "",
//             order: r.order,
//             refundStatus: r.status,
//             refundReasons: r.reasons || [],
//             refundPaymentStatus: r.paymentStatus,
//             refundId: r._id,
//             inputValue2: r.inputValue2,
//           }));

//         // Step 3: Final merged result
//         const finalMerged = [...combined, ...unmatchedRefunds];
//         setMergedData(finalMerged);
//       } catch (error) {
//         console.error("❌ Error fetching or merging data:", error);
//       }
//     };

//     if (campaignName) {
//       fetchAllData();
//     }
//   }, [campaignName]);

//   const handleApprove = async (orderId) => {
//     try {
//       await axios.post(`${Config.API_URL}/api/approve-order`);
//       setData((prevData) =>
//         prevData.map((item) =>
//           item.orderId === orderId ? { ...item, status: 'Approved' } : item
//         )
//       );
//     } catch (error) {
//       console.error('Error approving order:', error);
//     }
//   };



//   // Drag-scroll logic
//   let isDown = false;
//   let startX;
//   let scrollLeft;

//   const handleMouseDown = (e) => {
//     const slider = e.currentTarget;
//     isDown = true;
//     slider.classList.add('active');
//     startX = e.pageX - slider.offsetLeft;
//     scrollLeft = slider.scrollLeft;
//   };

//   const handleMouseLeave = (e) => {
//     isDown = false;
//     e.currentTarget.classList.remove('active');
//   };

//   const handleMouseUp = (e) => {
//     isDown = false;
//     e.currentTarget.classList.remove('active');
//   };

//   const handleMouseMove = (e) => {
//     if (!isDown) return;
//     e.preventDefault();
//     const slider = e.currentTarget;
//     const x = e.pageX - slider.offsetLeft;
//     const walk = (x - startX) * 2;
//     slider.scrollLeft = scrollLeft - walk;
//   };

//   return (
//     <div className="container mt-5">
//       <div
//         className="table-container"
//         style={{
//           overflowX: 'auto',
//           cursor: 'grab',
//         }}
//         onMouseDown={handleMouseDown}
//         onMouseLeave={handleMouseLeave}
//         onMouseUp={handleMouseUp}
//         onMouseMove={handleMouseMove}
//       >
//         <table className="table is-fullwidth" style={{ minWidth: '1500px' }}>
//           <thead>
//             <tr>
//               <th className="customStyle">Full Name</th>
//               <th className="customStyle">Instagram</th>
//               <th className="customStyle">Facebook</th>
//               <th className="customStyle">Twitter</th>
//               <th className="customStyle">YouTube</th>
//               <th className="customStyle">Custom Social</th>
//               <th className="customStyle">Gender</th>
//               <th className="customStyle">Whatsapp</th>
//               <th className="customStyle">Phone</th>
//               <th className="customStyle">Custom MarketPlace</th>
//               <th className="customStyle">Custom Review</th>
//               <th className="customStyle">Custom Profile Link</th>
//               <th className="customStyle">Email</th>
//               <th className="customStyle">Order</th>
//               <th className="customStyle">Quantity</th>
//               <th className="customStyle">Product Amount</th>
//               <th className="customStyle">Date</th>
//               <th className="customStyle">Student</th>
//               <th className="customStyle">College</th>
//               <th className="customStyle">Manager</th>
//               <th className="customStyle">Whatsapp Group</th>
//               <th className="customStyle">Pin Code</th>
//               <th className="customStyle">City</th>
//               <th className="customStyle">Product Question</th>

//               <th className="customStyle">Bank Name</th>
//               <th className="customStyle">Ifsc</th>
//               <th className="customStyle">Beneficiary Name</th>
//               <th className="customStyle">Account Number</th>
//               <th className="customStyle">UPI Number</th>
//               <th className="customStyle">Invoice Number</th>
//               <th className="customStyle">Deliverable Link</th>
//               <th className="customStyle">Actions</th>

//             </tr>
//           </thead>
//           <tbody>
//             {mergedData.map((item, index) => (
//               <tr key={index}>
//                 {/* Existing order fields */}
//                 <td className="customStyle">{item.FullName}</td>
//                 <td className="customStyle">{item.AuthInstagram}</td>
//                 <td className="customStyle">{item.AuthFacebook}</td>
//                 <td className="customStyle">{item.AuthTwitter}</td>
//                 <td className="customStyle">{item.AuthYouTube}</td>
//                 <td className="customStyle">{item.AuthCustomSocial}</td>
//                 <td className="customStyle">{item.gender}</td>
//                 <td className="customStyle">{item.whatsapp}</td>
//                 <td className="customStyle">{item.Phone}</td>
//                 <td className="customStyle">{item.customMarketPlaceName}</td>
//                 <td className="customStyle">{item.review}</td>
//                 <td className="customStyle">{item.customForoum}</td>
//                 <td className="customStyle">{item.email}</td>
//                 <td className="customStyle">{item.order}</td>
//                 <td className="customStyle">{item.quantity}</td>
//                 <td className="customStyle">{item.productAmount}</td>
//                 <td className="customStyle">{item.date}</td>
//                 <td className="customStyle">{String(item.student) === 'true' ? 'Yes' : 'No'}</td>
//                 <td className="customStyle">{item.collegeName}</td>
//                 <td className="customStyle">{item.manger}</td>
//                 <td className="customStyle">{item.whatsappGroup}</td>
//                 <td className="customStyle">{item.pinCode}</td>
//                 <td className="customStyle">{item.city}</td>
//                 <td className="customStyle">{item.productSS}</td>
//                 <td className="customStyle">{item.bankName}</td>
//                 <td className="customStyle">{item.ifsc}</td>
//                 <td className="customStyle">{item.beneficiaryName}</td>
//                 <td className="customStyle">{item.accountNumber}</td>
//                 <td className="customStyle">{item.UPI}</td>
//                 <td className="customStyle">{item.invoiceNumber}</td>

//                 {/* Refund data fields */}
//                 {/* <td className="customStyle">{item.refundStatus}</td>
//                 <td className="customStyle">
//                   {Array.isArray(item.refundReasons)
//                     ? item.refundReasons.join(', ')
//                     : item.refundReasons}
//                 </td> */}
//                 {/* <td className="customStyle">{item.refundPaymentStatus}</td>
//                 <td className="customStyle">
//                   {item.inputValue3 ? (
//                     <a href={`${Config.API_URL}/${item.inputValue3}`} target="_blank" rel="noopener noreferrer">View</a>
//                   ) : (
//                     '-'
//                   )}
//                 </td>
//                 <td className="customStyle">
//                   {item.inputValue4 ? (
//                     <a href={`${Config.API_URL}/${item.inputValue4}`} target="_blank" rel="noopener noreferrer">View</a>
//                   ) : (
//                     '-'
//                   )}
//                 </td> */}
//                 <td className="customStyle">
//                   {item.inputValue2}
//                 </td>

//                 {/* Action Button */}
//                 <td className="customStyle">
//                   <button
//                     onClick={() => handleApprove(item.orderId)}
//                     className="button is-primary"
//                   >
//                     Reminder
//                   </button>
//                 </td>
//               </tr>
//             ))}
//           </tbody>

//         </table>
//       </div>
//     </div>
//   );
// };

// export default Table;



import React, { useState, useEffect } from "react";
import axios from "axios";
import { Config } from "../.env.js";
import { useLocation } from "react-router-dom";

const Table = () => {
  const [data, setData] = useState([]);
  const location = useLocation();
  const campaignName = location.state?.campaignName;

  const [orders, setOrders] = useState([]);
  const [refunds, setRefunds] = useState([]);
  const [mergedData, setMergedData] = useState([]);

  useEffect(() => {
    const fetchAllData = async () => {
      try {
        const [orderRes, refundRes] = await Promise.all([
          axios.get(`${Config.API_URL}/api/order-data`, {
            params: { campaignName },
          }),
          axios.get(`${Config.API_URL}/api/refunds`), // Remove campaignName filter
        ]);

        const orderData = orderRes.data;
        const refundData = refundRes.data;
        console.log("refundData", refundData);
        console.log("orderData", orderData);

        setOrders(orderData);
        setRefunds(refundData);

        // Map refunds by contactId for fast lookup
        const refundMap = refundData.reduce((acc, item) => {
          if (item.contactId) acc[item.contactId] = item;
          return acc;
        }, {});

        // Step 1: Orders with matched refund info only
        const combined = orderData
          .filter((order) => refundMap[order.contactId]) // Only include orders with matching refunds
          .map((order) => {
            const refund = refundMap[order.contactId];
            return {
              ...order,
              refundStatus: refund?.status || null,
              refundReasons: refund?.reasons || [],
              refundPaymentStatus: refund?.paymentStatus || null,
              refundId: refund?._id || null,
              inputValue2: refund?.inputValue2 || null,
              bankName: refund?.bankName || null,
              ifsc: refund?.ifsc || null,
              beneficiaryName: refund?.beneficiaryName || null,
              accountNumber: refund?.accountNumber || null,
              UPI: refund?.UPI || null,
              invoiceNumber: refund?.invoiceNumber || null,
              invoiceReceived: refund?.invoiceReceived || null,
              profileVisibility: refund?.profileVisibility || null,
              product1: refund?.product1 || null,
              contactId: refund?.contactId || null,
              campaignName: refund?.campaignName || null,
            };
          });

        // Step 2: Set merged data (no unmatched refunds)
        setMergedData(combined);
      } catch (error) {
        console.error("❌ Error fetching or merging data:", error);
      }
    };

    if (campaignName) {
      fetchAllData();
    }
  }, [campaignName]);

  const handleApprove = async (orderId) => {
    try {
      await axios.post(`${Config.API_URL}/api/approve-order`);
      setData((prevData) =>
        prevData.map((item) =>
          item.orderId === orderId ? { ...item, status: "Approved" } : item
        )
      );
    } catch (error) {
      console.error("Error approving order:", error);
    }
  };

  // Drag-scroll logic
  let isDown = false;
  let startX;
  let scrollLeft;

  const handleMouseDown = (e) => {
    const slider = e.currentTarget;
    isDown = true;
    slider.classList.add("active");
    startX = e.pageX - slider.offsetLeft;
    scrollLeft = slider.scrollLeft;
  };

  const handleMouseLeave = (e) => {
    isDown = false;
    e.currentTarget.classList.remove("active");
  };

  const handleMouseUp = (e) => {
    isDown = false;
    e.currentTarget.classList.remove("active");
  };

  const handleMouseMove = (e) => {
    if (!isDown) return;
    e.preventDefault();
    const slider = e.currentTarget;
    const x = e.pageX - slider.offsetLeft;
    const walk = (x - startX) * 2;
    slider.scrollLeft = scrollLeft - walk;
  };

  return (
    <div className="container mt-5">
      <div
        className="table-container"
        style={{
          overflowX: "auto",
          cursor: "grab",
        }}
        onMouseDown={handleMouseDown}
        onMouseLeave={handleMouseLeave}
        onMouseUp={handleMouseUp}
        onMouseMove={handleMouseMove}
      >
        <table className="table is-fullwidth" style={{ minWidth: "1500px" }}>
          <thead>
            <tr>
              <th className="customStyle">Full Name</th>
              <th className="customStyle">Instagram</th>
              <th className="customStyle">Facebook</th>
              <th className="customStyle">Twitter</th>
              <th className="customStyle">YouTube</th>
              <th className="customStyle">Custom Social</th>
              <th className="customStyle">Gender</th>
              <th className="customStyle">Whatsapp</th>
              <th className="customStyle">Phone</th>
              <th className="customStyle">Custom MarketPlace</th>
              <th className="customStyle">Custom Review</th>
              <th className="customStyle">Custom Profile Link</th>
              <th className="customStyle">Email</th>
              <th className="customStyle">Order</th>
              <th className="customStyle">Quantity</th>
              <th className="customStyle">Product Amount</th>
              <th className="customStyle">Date</th>
              <th className="customStyle">Student</th>
              <th className="customStyle">College</th>
              <th className="customStyle">Manager</th>
              <th className="customStyle">Whatsapp Group</th>
              <th className="customStyle">Pin Code</th>
              <th className="customStyle">City</th>
              <th className="customStyle">Product Question</th>
              <th className="customStyle">Bank Name</th>
              <th className="customStyle">Ifsc</th>
              <th className="customStyle">Beneficiary Name</th>
              <th className="customStyle">Account Number</th>
              <th className="customStyle">UPI Number</th>
              <th className="customStyle">Invoice Number</th>
              <th className="customStyle">Deliverable Link</th>
              <th className="customStyle">Actions</th>
            </tr>
          </thead>
          <tbody>
            {mergedData.map((item, index) => (
              <tr key={index}>
                <td className="customStyle">{item.FullName}</td>
                <td className="customStyle">{item.AuthInstagram}</td>
                <td className="customStyle">{item.AuthFacebook}</td>
                <td className="customStyle">{item.AuthTwitter}</td>
                <td className="customStyle">{item.AuthYouTube}</td>
                <td className="customStyle">{item.AuthCustomSocial}</td>
                <td className="customStyle">{item.gender}</td>
                <td className="customStyle">{item.whatsapp}</td>
                <td className="customStyle">{item.Phone}</td>
                <td className="customStyle">{item.customMarketPlaceName}</td>
                <td className="customStyle">{item.review}</td>
                <td className="customStyle">{item.customForoum}</td>
                <td className="customStyle">{item.email}</td>
                <td className="customStyle">{item.order}</td>
                <td className="customStyle">{item.quantity}</td>
                <td className="customStyle">{item.productAmount}</td>
                <td className="customStyle">{item.date}</td>
                <td className="customStyle">
                  {String(item.student) === "true" ? "Yes" : "No"}
                </td>
                <td className="customStyle">{item.collegeName}</td>
                <td className="customStyle">{item.manger}</td>
                <td className="customStyle">{item.whatsappGroup}</td>
                <td className="customStyle">{item.pinCode}</td>
                <td className="customStyle">{item.city}</td>
                <td className="customStyle">{item.productSS}</td>
                <td className="customStyle">{item.bankName}</td>
                <td className="customStyle">{item.ifsc}</td>
                <td className="customStyle">{item.beneficiaryName}</td>
                <td className="customStyle">{item.accountNumber}</td>
                <td className="customStyle">{item.UPI}</td>
                <td className="customStyle">{item.invoiceNumber}</td>
                <td className="customStyle">{item.inputValue2}</td>
                <td className="customStyle">
                  <button
                    onClick={() => handleApprove(item.orderId)}
                    className="button is-primary"
                  >
                    Reminder
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Table;